<template>
    <div class="border-b mt-4 bg-white">
        <div class="ml-4 mr-4 mb-2 flex">
            <div class="flex flex-col justify-center" v-if="showFeatured && user.type == 'pro'">
                <button
                    class="tooltip"
                    type="button"
                    @click.prevent="onToggleFeaturedPro"
                    title="Add pro to storefront"
                >
                    <svg-vue
                        icon="check-mark-solid"
                        title="Favorite"
                        :class="
                            pro.connection.featured
                                ? 'h-6 mr-3 fill-salesium-blue hover:cursor-pointer'
                                : 'h-6 mr-3 fill-neutral-200 hover:cursor-pointer'
                        "
                    />
                    <div class="tooltiptext hover:cursor-pointer">
                        {{ toggleProMessage }}
                    </div>
                </button>
                <div class="tooltip mt-1 pt-1" v-if="user.type == 'pro'">
                    <svg-vue
                        icon="check-mark-solid"
                        title="Favorite"
                        :class="
                            pro.connection.featured_back
                                ? 'h-6 mr-3 fill-salesium-blue'
                                : 'h-6 mr-3 fill-neutral-200'
                        "
                    />
                    <div class="tooltiptext">
                        {{ proStorefrontRelationMessage }}
                    </div>
                </div>
            </div>
            <div>
                <div class="xl:mb-0 flex items-start">
                    <button
                        type="button"
                        title="View Pro info"
                        @click.prevent="goToProStorefront"
                        class="flex"
                    >
                        <img
                            v-show="!showingDefaultAvatar"
                            @load="showingDefaultAvatar = false"
                            :src="pro.avatar_uri"
                            class="w-8 h-8 z-0 mr-2 rounded-full outline:none default-avatar-icon"
                            :class="
                                pro.care_score > 3
                                    ? pro.care_score >= 4
                                        ? 'badgeBlue'
                                        : 'badgeGreen'
                                    : ''
                            "
                            alt="Pro user avatar"
                        />
                        <SvgVue
                            v-show="showingDefaultAvatar"
                            icon="circle-user"
                            title="default user avatar"
                            class="h-6 mr-2 hover:cursor-pointer rounded-full bg-white"
                            :class="
                                pro.type == 'pro'
                                    ? pro.care_score > 3
                                        ? pro.care_score >= 4
                                            ? 'fill-salesium-blue'
                                            : 'fill-salesium-green'
                                        : ''
                                    : ''
                            "
                        />
                        <div class="md:text-mini-lg text-hint font-bold">
                            {{ pro.display_name }}
                        </div>
                    </button>
                </div>
                <div class="mt-1 ml-2 md:text-mini-base">
<!--                    <div v-if="pro.phones">
                        {{ cardPhone}}
                    </div>
-->
                    <div class="md:text-mini-base text-hint font-normal"
                        v-if="this.pro.business_location">
                        {{ pro.business_location.city}}, {{pro.business_location.state_province}}
                    </div>
                    <div class="flex items-center" v-if="pro.subindustry ">
<!--                        <div class="mr-3 h-4 w-4 inline-block">
                            <svg-vue
                                :icon="industryIcons[pro.industry.name].icon"
                                class="fill-black h-4 w-4"
                            />
                        </div> -->
                        <p class="text-hint">{{ subindustryString }}</p>
                    </div>
                </div>
            </div>
            <div v-if="user" class="flex flex-col grow items-end justify-normal">
                <button
                    class="tooltip"
                    type="button"
                    @click.prevent="openPingModal"
                    title="Ping this pro"
                >
                    <div class="flex items-center hover:cursor-pointer pb-1">
                        <SvgVue
                            icon="salesium-logo-plain"
                            title="Ping"
                            class="h-6 mr-1"
                            @click.prevent="openPingModal"
                        />
                        Ping
                    </div>
                </button>
                <button
                    class="tooltip"
                    type="button"
                    @click.prevent="openShareModal"
                    title="Share this pro"
                >
                    <div class="flex items-center hover:cursor-pointer pb-1">
<!--                        <SvgVue
                            icon="Share Icon 1"
                            title="Share"
                            class="h-6 mr-1"
                            @click.prevent="openShareModal"
                        />-->
                        Share
                    </div>
                </button>
                <div v-if="pro.distance">
                    {{ pro.distance.toFixed(1) }}mi
                </div>
            </div>
            <div v-else class="flex flex-col grow items-end justify-normal">
                <div v-if="pro.distance">
                    {{ pro.distance.toFixed(1) }}mi
                </div>
            </div>
            <!--
            <div v-if="user" class="flex flex-col grow items-end justify-normal">
                <button
                    class="tooltip"
                    type="button"
                    @click.prevent="openPingModal"
                    title="Ping this pro"
                >
                    <div>  class="flex items-center hover:cursor-pointer pb-1">
                        <svg-vue
                            icon="Ping with lower case"
                            title="Ping"
                            class="h-10 mr-1"
                            @click.prevent="openPingModal"
                        />
                    </div>
                </button>
                <button
                    class="tooltip"
                    type="button"
                    @click.prevent="openShareModal"
                    title="Share this pro"
                >
                    <div>  class="flex items-center hover:cursor-pointer pb-1">
                        <svg-vue
                            icon="Share with lower case 1"
                            title="Share"
                            class="h-10 mr-1"
                            @click.prevent="openShareModal"
                        />
                    </div>
                </button>
            </div>
            -->
        </div>
    </div>
</template>

<script>
import { industryIcons } from "../../../constants/industryIcons";
export default {
    // TODO dynamically display values based on returned data
    props: ["pro", "user", "showFeatured", "isLast"] ,
    data() {
        return {
            industryIcons,
            showingDefaultAvatar: true,
        };
    },
    computed: {
        randomNumber() {
            return Math.floor(Math.random() * 2);
        },
        toggleProMessage() {
            return this.pro.connection.featured
                ? "Remove Pro from your storefront"
                : "Add Pro to your storefront";
        },
        proStorefrontRelationMessage() {
            return this.pro.connection.featured_back
                ? "This Pro has added you to their Storefront"
                : "This Pro has not added you to their Storefront";
        },
        subindustryString() {
            if (this.pro.subindustry != null) {
                return this.pro.subindustry.tag
                    .replaceAll("_", " ")
                    .substring(1);
            } else {
                return " ";
            }
        },
        cardPhone() {
            //console.log( this.pro.phones);
            for( let i = 0; i < this.pro.phones.length; i++){
                if(this.pro.phones[i].label === 'primary'|| this.pro.phones[i].label === 'Mobile') {
                    let stripped = this.pro.phones[i].value.replaceAll( /[-. ()]/g, '');
                    //console.log( 'stripped' + stripped);
                    let display = stripped.substring( 0, 3)
                        + '-' + stripped.substring( 3, 6)
                        + '-' + stripped.substring( 6, 10);
                    //console.log( 'display' + display);
                    return display;
                }
            }
            return null;
        }
    },
    methods: {
        openPingModal() {
            this.$emit("openPingModal", this.pro);
        },
        openShareModal() {
            this.$emit( "openShareModal", this.pro);
        },
        goToProStorefront() {
            // window.location.href = "/storefront/" + this.pro.username;
            window.open("/storefront/" + this.pro.username, '+_blank');
        },
        onToggleFeaturedPro() {
            // TODO: handle toggling if a pro displays on a user's storefront
            if (this.pro.connection.featured == true) {
                axios
                    .post("/api/connections/" + this.pro.id + "/unfeature")
                    .then((response) => {
                        if(response.data.success === true){
                            this.pro.connection.featured = false
                        }
                    })
                    .catch((error) => {
                        alert("Could not unfeature this pro");
                    });
            } else if (this.pro.connection.featured == false) {
                axios
                    .post("/api/connections/" + this.pro.id + "/feature")
                    .then((response) => {
                        if(response.data.success === true){
                            this.pro.connection.featured = true
                        }
                    })
                    .catch((error) => {
                        alert("could not feature this pro");
                    });
            }
        },
    },
    mounted() {
        console.log( 'connected pro');
        console.log( this.pro);
        console.log( 'pro distance:');
        console.log( this.pro.distance);
    }
};
</script>

<style scoped>
.tooltip {
    position: relative;
    display: inline-block;
}

.tooltip:hover {
    cursor: help;
}

/* Tooltip text */
.tooltip .tooltiptext {
    opacity: 0;
    visibility: hidden;
    width: 200px;
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;

    /* Position the tooltip text - see examples below! */
    position: absolute;
    z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
    transition-property: opacity;
    transition-duration: 0.7s;
    opacity: 1;
    visibility: visible;
}
.badgeBlue {
    border-width: 4px;
}
.badgeGreen {
    border-width: 4px;
}
</style>
